/* eslint-disable max-len */
import { SvgProps } from './types'

export const MapIcon = ({ color, className }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="57"
      height="57"
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clip-path="url(#clip0_89_5903)">
        <path 
          d="M28.5812 48.8222C32.2955 42.6934 35.7667 36.3585 38.8047 29.8651C41.568 23.9634 44.7857 17.5599 42.0858 11.0348C39.8931 5.73542 34.6414 2.13209 28.9035 2C28.782 2 28.6657 2 28.5442 2H28.4755C28.354 2 28.2378 2 28.1163 2C22.3837 2.14265 17.1372 5.75127 14.9498 11.0559C12.2605 17.5863 15.4835 23.9846 18.2573 29.8809C21.3059 36.3691 24.7877 42.6934 28.5125 48.8222" 
          stroke={drawColor} 
          strokeWidth="2.5" 
        />
        <path 
          d="M37.6847 41.4675H46.9941L55.1677 54H37.6847H19.3087H2L10.1735 41.4675H19.3087" 
          stroke={drawColor} 
          strokeWidth="2.5" 
        />
        <path 
          d="M22.6901 49.0969H34.3402" 
          stroke={drawColor} 
          strokeWidth="2.5" 
        />
        <path 
          d="M38.6674 16.0539L28.5231 7.84863L18.3788 16.0539" 
          stroke={drawColor} 
          strokeWidth="2.5" 
        />
        <path 
          d="M26.1244 25.8124V19.9478H30.9218V25.8124" 
          stroke={drawColor} 
          strokeWidth="2.5" 
        />
        <path 
          d="M21.6863 16.2336V25.8126H35.3599V16.2336" 
          stroke={drawColor} 
          strokeWidth="2.5" 
        />
      </g>
      <defs>
        <clipPath id="clip0_89_5903">
          <rect width="56" height="56" fill="white" transform="translate(0.5 0.0200195)" />
        </clipPath>
      </defs>
    </svg>
  )
}
